import { render, staticRenderFns } from "./BoxListRecognitionDialog.vue?vue&type=template&id=ef59db6a&scoped=true&"
import script from "./BoxListRecognitionDialog.vue?vue&type=script&lang=js&"
export * from "./BoxListRecognitionDialog.vue?vue&type=script&lang=js&"
import style0 from "./BoxListRecognitionDialog.vue?vue&type=style&index=0&id=ef59db6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef59db6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef59db6a')) {
      api.createRecord('ef59db6a', component.options)
    } else {
      api.reload('ef59db6a', component.options)
    }
    module.hot.accept("./BoxListRecognitionDialog.vue?vue&type=template&id=ef59db6a&scoped=true&", function () {
      api.rerender('ef59db6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/BoxListRecognitionDialog.vue"
export default component.exports